/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { AppRoutes } from '@/constants/routes';
import { TriggerFormView } from '@antflow-triggers-component';
import { Button } from 'primereact/button';
import React from 'react';
import { useNavigate } from 'react-router';

export const NewTrigger: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToViewer = () => {
    navigate(AppRoutes.trigger.index.url());
  };

  return (
    <div className="p-4 w-full text-left">
      <div className=" ml-4">
        <h2 className="ml-2">New Trigger</h2>
        <Button
          icon="pi pi-angle-left"
          label="back to triggers"
          size="small"
          onClick={handleBackToViewer}
          className=" p-button-secondary"
        />
      </div>
      <TriggerFormView onSave={handleBackToViewer} onCancel={handleBackToViewer} />
    </div>
  );
};
